import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { markFirstLoginIfNeeded } from '../utils/mobileAppLinks';

export default function AuthCallbackPage() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const token = searchParams.get('token');
        const next = searchParams.get('next');
        if (token) {
            localStorage.setItem('token', token);
            localStorage.setItem('sport_school_token', token);
            markFirstLoginIfNeeded();
            navigate(next || '/', { replace: true });
            return;
        }
        navigate('/login', { replace: true });
    }, [navigate, searchParams]);

    return (
        <div style={{ padding: 24, textAlign: 'center' }}>
            Вход в аккаунт...
        </div>
    );
}
